export function handleResponse(response, from, sendResponseBody = false) {
  if (!response.ok) {
    return Promise.reject(sendResponseBody ? response : response.status);
  }
  return response.json();
}
